import axios from 'axios';
import store from "./store/store";

// console.log('axios sc', serverConfig);

const authrequest = axios.create({
  // baseURL: serverConfig.url + ':' + serverConfig.port,
  baseURL: 'http://localhost:1337',
});
export default authrequest;



// WEBPACK FOOTER //
// ./src/axios-auth.js